import React from "react";
import TableNumberBase from "../TableNumberBase";
import "./TableNumberPrimaryKey.css";

function TableNumberPrimaryKey() {
  return (
    <div className="table-number-primary-key">
      <TableNumberBase />
    </div>
  );
}

export default TableNumberPrimaryKey;
